import { LoadablePaint } from '@confluence/loadable';

export const SpaceOverviewLoader = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-space-overview" */ '../src/SpaceOverview.tsx'))
			.SpaceOverview,
});
